import React, { CSSProperties, FC } from 'react';

interface Props {
  className?: string;
  vertical?: boolean;
  style?: CSSProperties;
}

export const Divider: FC<Props> = ({ className, vertical = false, style }) => {
  if (vertical) {
    return <div className={`absolute top-0 bottom-0 right-0 bg-neutral-gray ${className}`} style={{ width: 1, ...style }} />;
  }

  return <div className={`w-full bg-neutral-gray ${className}`} style={{ height: 1, ...style }} />;
};

export default Divider;
